// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ab08e371","156":"fbe8f69c","185":"1d591725","200":"fd30ade6","241":"a0e8db0b","263":"b69ce9df","389":"f109710c","565":"6fd678aa","654":"293b3567","768":"f1dce226"}[chunkId] + ".chunk.js";
};